import React, {FunctionComponent, useContext} from "react";
import {PageContext, PageContextProps} from "/src/contexts/Page";
import {User} from "/src/domain/shared/User";

import {ChallengeProtocolData} from "/src/domain/challenges/ChallengeProtocolData";

import theme from '/src/ui/shared/styledTheme'
import { theme as themeColor } from '/src/assets/theme';

import {Header} from "/src/ui/shared/header";
import {Footer} from "/src/ui/shared/footer";
import {UpcomingRacesContainer} from "/src/ui/shared/upcomingRaces";
import ChallengeHeader from "/src/ui/challengeProtocol/ChallengeHeader";
import {LeaderBoardContainer} from "/src/ui/challengeProtocol/leaderBoard/LeaderBoardContainer";
import {CurrentUserResultsContainer} from "/src/ui/challengeProtocol/currentUserResults/CurrentUserResultsContainer";
import UserFeedback from "/src/ui/challengeProtocol/userFeedback/UserFeedback";
import {ProtocolsContainer} from "/src/ui/challengeProtocol/ProtocolsContainer";
import {ChallengeProvider} from '/src/contexts/ChallengeContext'
import {ThemeProvider, StyledEngineProvider, GlobalStyles} from "@mui/material";
import {ThemeProvider as ThemeProviderForStyles, createStyles, makeStyles} from "@mui/styles";
import {Diplom} from "./Diplom";
import {EmptyProtocolBanner} from "./EmptyProtocolBanner";
import {PointTablesContainer} from "./pointTables/PointTablesContainer";
import {SystemMessage} from "./SystemMessage";


export const ChallengeProtocolApp: FunctionComponent = () => {
    const {pageData, currentUser} = useContext(PageContext) as PageContextProps;

    if (pageData === null) return null;
    const challengeProtocol = pageData as ChallengeProtocolData;

    return <StyledEngineProvider injectFirst>
        <GlobalStyles
            styles={{
                'body': {
                    backgroundColor: themeColor.WHITE_COLOR,
                },
            }}
        />
        <ThemeProvider theme={theme}>
            <ThemeProviderForStyles theme={theme}>
                <ChallengeProvider>
                    <App
                        challengeProtocol={challengeProtocol}
                        currentUser={currentUser}
                    />
                </ChallengeProvider>
            </ThemeProviderForStyles>
        </ThemeProvider>
    </StyledEngineProvider>;
}

interface AppProps {
    challengeProtocol: ChallengeProtocolData;
    currentUser?: User;
}

export const App: FunctionComponent<AppProps> = ({
                                                     challengeProtocol,
                                                     currentUser
                                                 }) => {
    const classes = useStyles();
    const isProtocolsEmpty = challengeProtocol.protocols.every(p => p.records.length === 0);

    return <>
        <Header currentUser={currentUser}/>
        <div className={classes.contentContainer}>
            <ChallengeHeader
                challenge={challengeProtocol.challenge}
            />
            <UpcomingRacesContainer withHeader={false} startReg={challengeProtocol.challenge.startreg}/>
            {challengeProtocol.challenge.isProtocolVisible && <LeaderBoardContainer
                challengeType={challengeProtocol.challenge.formula}
                protocols={challengeProtocol.protocols}
            />}
            {isProtocolsEmpty && <EmptyProtocolBanner/>}
            <CurrentUserResultsContainer
                protocols={challengeProtocol.protocols}
                currentUser={currentUser}
                challengeType={challengeProtocol.challenge.formula}
            />
            {challengeProtocol.challenge.diplomas && challengeProtocol.challenge.diplomas.length > 0 &&
                <Diplom diplomas={challengeProtocol.challenge.diplomas} isPremium={Boolean(currentUser?.isPremium)
                    || Boolean(challengeProtocol.challenge.isDiplomaFree)}/>}
            <SystemMessage message={challengeProtocol.systemMessage} goalInfo={challengeProtocol.goalInfo} />
            <UserFeedback
                currentUser={currentUser}
                challengeProtocol={challengeProtocol}
            />

            <ProtocolsContainer
                protocols={challengeProtocol.protocols}
                challenge={challengeProtocol.challenge}
                currentUser={currentUser}
                ippodrom={challengeProtocol.ippodrom}
                clubsRating={challengeProtocol.clubsRating || []}/>
            <PointTablesContainer pointTables={challengeProtocol.pointTables}/>
        </div>
        <Footer/>
    </>;
}

const useStyles = makeStyles((theme) => createStyles({
    contentContainer: {
        [theme.breakpoints.up("sm")]: {
            maxWidth: "1100px",
            margin: "0 auto",
            minHeight: "calc(100vh - 20rem)",
        },
    }
}));
